/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["അ","ഉച്ച","പുലർച്ചെ","രാവിലെ","ഉച്ചയ്ക്ക്","ഉച്ചതിരിഞ്ഞ്","വൈകുന്നേരം","സന്ധ്യ","രാത്രി"],["അർദ്ധരാത്രി","ഉച്ച","പുലർച്ചെ","രാവിലെ","ഉച്ചയ്ക്ക്","ഉച്ചതിരിഞ്ഞ്","വൈകുന്നേരം","സന്ധ്യ","രാത്രി"],u],[["അർദ്ധരാത്രി","ഉച്ച","പുലർച്ചെ","രാവിലെ","ഉച്ചയ്ക്ക്","ഉച്ചതിരിഞ്ഞ്","വൈകുന്നേരം","സന്ധ്യ","രാത്രി"],u,u],["00:00","12:00",["03:00","06:00"],["06:00","12:00"],["12:00","14:00"],["14:00","15:00"],["15:00","18:00"],["18:00","19:00"],["19:00","03:00"]]];
